import { ReactNode } from 'react';
import styled from '@emotion/styled';

const ToggleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 2px solid #36a3ff;
  border-radius: 16px;
  padding: 8px 16px;
  font-size: 17px;
  font-weight: 500;
  cursor: pointer;

  &:hover {
    border-color: #2a8dd9;
  }
`;

const Switch = styled.span<{ $on?: boolean }>`
  width: 51px;
  height: 31px;
  background: ${({ $on }) => ($on ? '#31bcf9' : '#d8d8d8')};
  border-radius: 16px;
  display: inline-block;
  position: relative;
  transition: background 0.22s ease;

  &::after {
    content: '';
    position: absolute;
    top: 2px;
    left: 2px;
    transform: translateX(${({ $on }) => ($on ? '20px' : '0')});
    width: 27px;
    height: 27px;
    background: white;
    border-radius: 50%;
    box-shadow: 0px 3px 1px 0px #0000000f, 0px 3px 8px 0px #00000026;
    transition: transform 0.22s ease;
  }
`;

interface ToggleCardProps {
  checked?: boolean;
  onToggle?: () => void;
  children?: ReactNode;
}

export function ToggleCard({ checked = true, onToggle, children = 'Free Trial Enabled' }: ToggleCardProps) {
  return (
    <ToggleWrapper onClick={onToggle}>
      <div>{children}</div>
      <Switch $on={checked} />
    </ToggleWrapper>
  );
}
